import { request } from '@@/plugin-request';

export function getMyPendingApprovalCount() {
  return request('/api/approvals/my-pending/count', { skipErrorHandler: true });
}

export function getMyPendingApprovals() {
  return request('/api/approvals/my-pending', { skipErrorHandler: true });
}

export function resendPendingApproval(type, id, approvalId) {
  return request(`/api/approvals/my-pending/${type}/${id}/approvers/${approvalId}/resend`, {
    method: 'POST',
    skipErrorHandler: true,
  });
}
